<template>
  <div>
    <h3 class="text-center">Plantilla de contrato para Maestrias</h3>
    <p class="text-center"><b>Use las palabras {clave} para ubicar los textos reemplazables</b></p>
    <hr />

    <v-row>
      <v-col>
        <vue-editor v-model="content"></vue-editor>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { VueEditor } from 'vue2-editor';
  export default {
    data() {
      return {
        content: `
        <h5 style="margin-bottom:1.5em;text-align: center;margin-top:0;color: black">
            <b> CONTRATO POR PRESTACION DE SERVICIOS ACADEMICOS DE POSTGRADO </b>
        </h5>
        <p>
            Conste por el tenor del presente documento privado, CONTRATO DE PRESTACIÓN DE SERVICIOS ACADÉMICOS
DE POSGRADO, mismo que a sólo reconocimiento de firmas y rúbricas ante Autoridad competente surtirá los
efectos de Instrumento Público, de conformidad con lo dispuesto por el Art. 519 y 1.297 del Código Civil con sujeción
a las siguientes cláusulas:
        </p>

        <p>  </p>
        <p>
            <b>PRIMERA. - (DE LAS PARTES)</b> <br>
            Son partes del presente documento: <br>
            I.1.- La Escuela de Negocios ESAM S.R.L., según Convenio marco de Cooperación académica Interinstitucional con
la {universidad_name}, con domicilio <span class="text-danger">{direccion_sede}</span> ciudad de <span class="text-danger">{ciudad_sede}</span> representada
por <span class="text-danger">{apoderado_esam}</span> con cédula de identidad N° <span class="text-danger">{apoderado_ci_esam}</span> expedida en <span class="text-danger">{representante_ci_exp}</span> vecina de ésta, de nacionalidad boliviana y hábil por
ley en su calidad de Gerente Regional, en adelante llamada <b>“ESAM.”</b>
        </p>
        <p>
            I.2.- El señor(a) <span class="text-danger">{participante}</span> de nacionalidad <span class="text-danger">{participante_nacionalidad}</span> domiciliado en <span class="text-danger">{participante_domicilio}</span> con C.I. <span class="text-danger">{participante_ci}</span>
            en adelante llamado <b>“EL POSGRADUANTE"</b>
        </p>
        <p>  </p>
        <p>
            <b>SEGUNDA. - (CARACTERÍSTICAS DEL PROGRAMA)</b> <br>
            - El programa tiene como propósito fundamental el
            perfeccionamiento al más alto nivel práctico y teórico de todos los temas a tratar en cada uno de los módulos del
            programa <span class="text-danger">{programa_nombre}</span>
        </p>

        <p>
            La estructura del programa está diseñado y orientado a profesionales de todas las áreas del saber humano, la
modalidad del desarrollo del programa formativo por la <b>ESAM</b> es virtual, entre la metodología empleada se destacan
las clases activas - participativas, prácticas, expositivas, apoyo audiovisual y apoyo en las TICs (si es necesario),
realizando de manera permanente el análisis de casos prácticos y apoyo de plataforma virtual Moodle.
        </p>

        <p>
            Para obtener el grado académico de Magister, el programa cumple una carga horaria determinada en base a las
horas virtuales, prácticas e investigación destinadas a trabajos prácticos en grupo o individuales, haciendo un total
de 2.400 horas académicas que tiene un equivalente a 60 créditos, en coherencia al Capítulo IV, Artículo 25 del
Reglamento del Sistema Nacional de Estudios de Posgrado de la Universidad Boliviana emitido por el Comité
Ejecutivo de la Universidad Boliviana (CEUB).
        </p>

        <p> </p>
        <p>
            <b>TERCERA. - (ESTRUCTURA ACADÉMICA DEL PROGRAMA)</b> <br>
            El <span class="text-danger">{programa_tipo}</span> está compuesta por <span class="text-danger">{programa_modulos}</span> módulos, los cuales se detallan a continuación:
        </p>
        {tabla_modulos}
        <br>

        <p>  </p>
        <p>
            <b>CUARTA. - (RESPONSABILIDADES DE LOS POSGRADUANTES)</b> <br>
            Son responsabilidades de los POSGRADUANTES: <br>
            a) Cumplir con todas las disposiciones estipuladas en el reglamento interno del programa y del Posgrado de la
{universidad_name}. <br>
b) Mantener y guardar respeto con las autoridades, docentes y sus compañeros. <br>

c) Someterse a las evaluaciones de cada uno de los módulos en los plazos estipulados, bajo sus diferentes
dimensiones. <br>
d) Evaluar bajo diferentes criterios establecidos por la coordinación académica el desarrollo del programa.
e) Para optar el certificado de diplomado, el cursante deberá presentar y aprobar un trabajo monográfico de
acuerdo al reglamento de trabajo de grado. <br>
f) Cumplir puntualmente con la inversión del programa en las fechas y montos establecidos. <br>
g) En coherencia con la normativa del CEUB, es obligación del alumno asistir a todas las clases ya sean presenciales o virtuales 
(80% de asistencia como mínimo) programadas en los Módulos, salvo motivo de fuerza mayor debidamente
justificado por escrito, y con los respaldos correspondientes. <br>
h) Entrega de documentación requerida por la {universidad_name}, en plazos y formatos definidos,
para la inscripción y tramitación de Titulo(s).
        </p>

        <p>  </p>
        <p>
            <b>QUINTA. - (RESPONSABILIDADES DE LA ESAM)</b> <br>
            a) La ESAM se compromete a viabilizar la titulación (Maestría con la {universidad_name}) de acuerdo al
proyecto académico propuesto, que cumple con la estructura curricular y la carga horaria del Comité
Ejecutivo de la Universidad Boliviana (CEUB) según el Capítulo IV en el Artículo 25 del Reglamento del
Sistema Nacional de Estudios de Posgrado de la Universidad Boliviana. <br>
b) Si por razones de fuerza mayor, algún docente no pueda desarrollar un Módulo, la ESAM se compromete a
reemplazar por otro con similar o superior formación y experiencia profesional académica. <br>
c) Como elemento diferencial sustancial la ESAM se compromete, a acompañar a lo largo del proceso de
desarrollo de su trabajo de grado con un docente guía de los dos talleres de estudio de caso y apoyo en
tecnologías informáticas. <br>
d) Garantizar la idoneidad, formación académica y capacidad académica del plantel docente. <br>
e) Proveer la infraestructura acorde al desarrollo del programa. <br>
f) Desarrollar los módulos de acuerdo a la propuesta académica de la Especialidad. <br>

LA ESAM se compromete a concluir el Programa <span class="text-danger">{programa_nombre}</span> hasta su finalización
de acuerdo al plan curricular ofertado y la (Titulación), debiendo cumplir con los compromisos asumidos
para tal efecto.
        </p>

        <p>  </p>
        <p>
            <b>SEXTA. - (DECLARACIÓN DE DEUDA). –</b> <br>
            EL POSGRADUANTE, declara ser deudor a la ESAM de la suma de Bs
            <span class="text-danger">{programa_monto}</span> (<span>{programa_monto_str}</span> 00/100 bolivianos), por el concepto de pago del
            PROGRAMA <span class="text-danger">{programa_nombre}</span>
        </p>

        <p>  </p>
        <p>
            <b>SEPTIMA. - (INVERSIÓN Y FORMA DE PAGO). -</b> <br>
            EL POSGRADUANTE, se compromete a realizar las cancelaciones
            económicas a la ESAM por los siguientes conceptos: <br> <br>
            a) Matrícula Bs <span class="text-danger">{programa_matricula_monto}</span> (<span class="text-danger">{programa_matricula_monto_str}</span> 00/100 bolivianos) (por única vez) <br>
            b) Colegiatura Bs <span class="text-danger">{programa_colegiatura_monto}</span> (<span class="text-danger">{programa_colegiatura_monto_str}</span> 00/100 bolivianos). <br>
            c) Los trámites de titulación de <span class="text-danger">{programa_tipo}</span>, podrán ser cancelados al contado o en cuotas, importe que estará sujeto
a la RESOLUCIÓN de Consejo Universitario de la {universidad_name}, (Resolución Rectoral N° 009/17
vigente a la fecha). <br>
            d) El pago podrá efectuarse en <span class="text-danger">{programa_cuotas}</span> cuotas <b>hasta el {dia_cada_mes} de cada mes</b>, pasada la fecha de pago, ingresará en
mora, donde el posgraduante quedará automáticamente deshabilitado de la plataforma Moodle, hasta la
regularización de los importes adeudados. <br>
            e) Queda claro que la inasistencia al módulo por parte del posgraduante o postergación del módulo en caso de algún
motivo de fuerza mayor, no exoneran al posgraduante de las obligaciones económicas pactadas en el presente
contrato. <br>
f) La solicitud de devolución económica solo se protocoliza dentro del mes de inscripción, mediante carta y respaldo
justificado.
        </p>
        <br>

        <p>
            <b>Todos los pagos son por adelantado y en base al siguiente plan de pagos.</b> <br>
            {tabla_plan_pagos}
        </p>
        <br>

        <p>  </p>
        <p>
            <b>OCTAVA.- (COMPROMISO DE PAGO, RETIRO Y ABANDONO).-</b> <br>
            - Por los compromisos económicos que adquirió
con la ESAM para la organización del programa, EL POSGRADUANTE se compromete a pagar el total de las cuotas
pactadas.
            <br> <br>
            <b>Retiro. -</b> 
            EL POSGRADUANTE que por razones justificadas deba acogerse al retiro, deberá comunicar con la debida
anticipación por escrito, acompañando la documentación que acredite que tiene pagados los módulos ya cursados,
pudiendo reincorporase en la siguiente versión, siempre y cuando el título y contenido del programa sean los
mismos, y que se encuentren ofertados en la presente sede u otra donde esté operando la ESAM, en un plazo
máximo de 6 meses, debiendo adecuarse a los precios vigentes del programa.
            <br> <br>
            <b>Abandono.- </b>
            Si EL POSGRADUANTE se desvincula del proceso académico sin la debida justificación por más de 60
días, el comité académico a través de la Unidad de Asesoría Legal procederá a la BAJA en el proceso académico sin
posibilidad de reincorporación.
        </p>

        <p>  </p>
        <p>
            <b>NOVENA. -(PAGO TOTAL A LA CULMINACION DEL PROGRAMA). -</b> <br>
            A la culminación del proceso, y ante el
incumplimiento de las obligaciones financieras con la ESAM (cuotas), el POSGRADUANTE entrará automáticamente
en mora sin necesidad de requerimiento judicial, notarial o legal alguno, haciéndose la deuda líquida, exigible y de
plazo vencido por el saldo del total de la deuda, pudiendo seguirse las acciones judiciales correspondientes.
        </p>

        <p>  </p>
        <p>
            <b>DÉCIMA. - (DOMICILIO REAL).</b> <br>
            Las partes establecen que para efectos de su legal citación podrán ser citados en
los domicilios declarados en sus generales de ley, teniendo la obligación de informar a la ESAM mediante carta
notarial en caso de que se realizará cambio de domicilio, de no hacerlo serán citados en el domicilio declarado por
ellos en el presente contrato.
        </p>

        <p> </p>
        <p>
            <b>DÉCIMA PRIMERA. - (ACEPTACIÓN AL PROGRAMA).- </b>  <br>
            EL POSGRADUANTE, acepta todas y cada una de las
exigencias del programa en cuanto a materias, horarios, suspensiones de clases, retrasos y otros inconvenientes
que la ESAM requiera y exija para llevar adelante el Programa.
        </p>
        
        <p>  </p>
        <p>
            <b>DÉCIMA SEGUNDA.- (ACEPTACIÓN)</b> <br>
            Nosotros, <b>“ESAM”</b>, con representación de {apoderado_esam} Gerente Regional por una
            parte y <b>“EL POSGRADUANTE”</b> por otra, de forma voluntaria y sin que medie ningún vicio del consentimiento,
declaramos nuestra total conformidad con todas y cada una de las cláusulas precedentes, en fe de lo cual firmamos
en doble ejemplar de un solo tenor y nos comprometemos a su fiel y estricto cumplimiento, el cual es firmado en la
ciudad de <span class="text-danger">{ciudad}</span> a los <span class="text-danger">{dias}</span> días del mes de <span class="text-danger">{mes}</span> del año <span class="text-danger">{anio_str}</span>.

            <table style="margin-top:8em;margin-left:auto; margin-right:auto; width:100%;text-align:center;">
                <tbody>
                    <tr>
                        <td> <img crossorigin="*" src="{url_firma}" alt="." width="200px"> </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td><span class="text-danger">{apoderado_esam}</span></td>
                        <td style="color:black"><span class="text-danger">{participante}</span></td>
                    </tr>
                    <tr>
                        <td> <b>GERENTE ESAM</b> </td>
                        <td style="color:black"> <b>POSGRADUANTE</b> </td>
                    </tr>
                    <tr>
                        <td> <b>C.I.</b> <span class="text-danger">{apoderado_ci_esam} {apoderado_ci_ext_esam}</span></td>
                        <td style="color:black"> <b>C.I.</b> <span class="text-danger">{participante_ci}</span></td>
                    </tr>
                </tbody>
            </table>
        </p>
        `,
      };
    },
    components: { VueEditor },
    watch: {},
    methods: {},
    mounted() {
      this.content = this.content.replace(/\s+/g, ' ');
      this.content = this.content.replace(/\n+/g, '\n');
    },
  };
</script>
